import React, { Component } from 'react'

import JobsTable from '../components/Session/JobsTable.js'
import Loader from 'react-loader-advanced'
import { connect } from 'react-redux'
import { loadJobs } from '../actions/jobs.js'

class JobsContainer extends Component {
  componentDidMount() {
    this.props.loadJobs(this.props.user.username)
  }

  render() {
    if (!this.props.user || !this.props.user.token) {
      return null
    }

    if (this.props.jobs.fetching) {
      return (
        <Loader show={this.props.jobs.fetching} message="Loading Sessions">
          ..
        </Loader>
      )
    }

    if (this.props.jobs.data.length === 0) {
      return 'No Jobs'
    }

    return (
      <div style={{ marginBottom: '100px' }}>
        <JobsTable
          loadJobs={this.props.loadJobs}
          configuration={this.props.configuration}
          user={this.props.user}
          jobs={this.props.jobs.data}
          fetching={this.props.jobs.fetching}
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    jobs: state.jobs,
    user: state.user,
    configuration: state.configuration,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    loadJobs: username => dispatch(loadJobs(username)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(JobsContainer)
